import { ReploError } from "schemas/errors";

export class BedrockConfigError extends ReploError {}

export class BedrockApiRequestError extends Error {
  code: string;
  status: number;
  // (Cole, 2026-07-08, REPL-28948): named for extractErrorId(); absent = not a Replo error response.
  reploErrorId?: string;

  constructor({
    code,
    status,
    message,
    reploErrorId,
  }: {
    code: string;
    status: number;
    message: string;
    reploErrorId?: string;
  }) {
    super(message);
    this.code = code;
    this.status = status;
    this.reploErrorId = reploErrorId;
  }
}
